import { render, staticRenderFns } from "./info_pc.vue?vue&type=template&id=2bc08c49&scoped=true&"
import script from "./info_pc.vue?vue&type=script&lang=js&"
export * from "./info_pc.vue?vue&type=script&lang=js&"
import style0 from "./info_pc.vue?vue&type=style&index=0&id=2bc08c49&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc08c49",
  null
  
)

export default component.exports